import * as Types from '../../../../../__generated__/GQL';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type CanUseEnrollTrustedDeviceQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CanUseEnrollTrustedDeviceQuery = { __typename: 'Query', canUseEnrollTrustedDevice: boolean };


export const CanUseEnrollTrustedDeviceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CanUseEnrollTrustedDevice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canUseEnrollTrustedDevice"}}]}}]} as unknown as DocumentNode<CanUseEnrollTrustedDeviceQuery, CanUseEnrollTrustedDeviceQueryVariables>;